/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Tool_Update_ProjectInputs */



/**
* | output |
* | --- |
* | "Updating project" |
*
* @param {Uno_Tool_Update_ProjectInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_tool_update_project = /** @type {((inputs?: Uno_Tool_Update_ProjectInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Tool_Update_ProjectInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktualisiere Projekt")
	return /** @type {LocalizedString} */ ("Updating project")
});